var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserWithShadow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 63,
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32 62.622c17.673 0 32-4.892 32-10.927 0-6.035-14.327-10.927-32-10.927-17.673 0-32 4.892-32 10.927 0 6.035 14.327 10.927 32 10.927Z",
  fill: "#F3F3F3"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 12.5,
  r: 12,
  fill: "#F9F9F9",
  stroke: "#D5D5D5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 27.5h21C49.956 27.5 56 33.544 56 41v10a3.5 3.5 0 0 1-3.5 3.5h-41A3.5 3.5 0 0 1 8 51V41c0-7.456 6.044-13.5 13.5-13.5Z",
  fill: "#F9F9F9",
  stroke: "#D5D5D5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.98 27.5a7.12 7.12 0 0 1-7.102 6.622h-3.756A7.12 7.12 0 0 1 23.02 27.5h17.96Z",
  fill: "#fff",
  stroke: "#D5D5D5"
})));
SvgUserWithShadow.displayName = "SvgUserWithShadow";
export { SvgUserWithShadow as ReactComponent };
export default SvgUserWithShadow;